module.exports = __webpack_public_path__ + "static/logo-tectonic-landscapes-large-1a936fdde032b0cbd588d020a831263e.svg";